export default {
  SET_PROJECTS(state, projects) {
    state.projects = projects
  },
  SET_PERIODS(state, periods) {
    state.periods = periods
  },
  ADD_PERIOD(state, period) {
    state.periods.unshift(period)
  },
  UPDATE_PERIOD(state, period) {
    const index = state.periods.findIndex((t) => t.id === period.id)
    Object.assign(state.periods[index], period)
  },
  REMOVE_PERIOD(state, periodId) {
    const index = state.periods.findIndex((t) => t.id === periodId)
    state.periods.splice(index, 1)
  },
  SET_STATEMENTS(state, statements) {
    state.statements = statements
  },
  ADD_STATEMENT(state, statement) {
    state.statements.unshift(statement)
  },
  UPDATE_STATEMENT(state, statement) {
    const index = state.statements.findIndex((t) => t.id === statement.id)
    if (index !== -1) {
      Object.assign(state.statements[index], statement)
    }
  },
  REMOVE_STATEMENT(state, statementId) {
    const index = state.statements.findIndex((t) => t.id === statementId)
    state.statements.splice(index, 1)
  },
  SET_GEOLOGY_USERS(state, users) {
    state.qpGeologyUsers = users
  },
  SET_ENGINEERING_USERS(state, users) {
    state.qpEngineeringUsers = users
  },
  UPDATE_PERIOD_ID(state, periodId) {
    state.selectedPeriodId = periodId
  },

  ADD_QP(state, qp) {
    state.qps.unshift(qp)
  },
  SET_QPS(state, qps) {
    state.qps = qps
  },
  UPDATE_QP(state, qp) {
    const index = state.qps.findIndex((t) => t.id === qp.id)
    Object.assign(state.qps[index], qp)
  },
  REMOVE_QP(state, qpId) {
    const index = state.qps.findIndex((t) => t.id === qpId)
    state.qps.splice(index, 1)
  },

  ADD_PROFESSIONAL_ORDER(state, professionalOrder) {
    state.professionalOrders.unshift(professionalOrder)
  },
  SET_PROFESSIONAL_ORDERS(state, professionalOrders) {
    state.professionalOrders = professionalOrders
  },
  UPDATE_PROFESSIONAL_ORDER(state, professionalOrder) {
    const index = state.professionalOrders.findIndex((t) => t.id === professionalOrder.id)
    Object.assign(state.professionalOrders[index], professionalOrder)
  },
  REMOVE_PROFESSIONAL_ORDER(state, id) {
    const index = state.professionalOrders.findIndex((t) => t.id === id)
    state.professionalOrders.splice(index, 1)
  },
  REMOVE_VARIANCE(state, id) {
    const index = state.variances.findIndex((t) => t.id === id)
    state.variances.splice(index, 1)
  },
  SET_VARIANCES(state, variances) {
    state.variances = variances
  }
}
